// import React from 'react';
// import t from '@zenlayer/zen-intl18';
// import { Icon, Tooltip } from '@zenlayer/zen-design';
// type Props = {
//   size?: number;
//   color?: string;
//   // tooltip?: string;
//   className?: string;
//   style?: React.CSSProperties;
// };
// export default function ZenPoint({
//   size,
//   color,
//   // tooltip = t('XXSBYXxbDpzn'),
//   className,
//   style = {},
// }: Props) {
//   if (size) {
//     style.fontSize = `${size}px`;
//   }
//   return ""
//   // return (
//   //   // <Tooltip title={<span>{tooltip}</span>}> </Tooltip>
//   //   <Icon
//   //     // type="general/ZenpointLine"
//   //     type="general/USDpointLine"
//   //     className={className}
//   //     style={{ lineHeight: 1, ...style, color }}
//   //   />
//   // );
// }
export var zenPoint = '$';